import { useEffect } from "react"
import { debounce } from "lodash"

export function useDebouncedEffect(callback: () => void, dependencies: any[], delay = 500) {
    useEffect(() => {
        const debouncedCallback = debounce(() => {
            callback()
        }, delay)

        debouncedCallback()

        return () => {
            debouncedCallback.cancel()
        }
    }, [...dependencies, delay])
}
